import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useI18n from '@i18n';
import { ICommonCard } from '@pages/statistics/common/interfaces';

const iconColors = {
    blue: '#8B5CF6',
    violet: '#AA7AEA',
    green: '#22C55E',
    red: '#EF4444',
};

const iconWrapColors = {
    blue: 'rgba(224, 242, 254, 0.5)',
    violet: 'rgba(237, 233, 254, 0.5)',
    green: 'rgba(220, 252, 231, 0.5)',
    red: 'rgba(254, 226, 226, 0.5)',
};

const Card: React.FC<ICommonCard> = ({ card }) => {
    const { t } = useI18n('Statistic');
    return (
        <div
            className="flex flex-col items-center p-3 w-[48%] xs:w-full rounded-3 last:mr-0 xs:py-4 sm:mr-8 sm:last:mr-0 lg:py-6 lg:px-4 xl:px-8"
            style={{ backgroundColor: iconWrapColors[card.iconColor] }}
            key={card.label}
        >
            <div className="flex flex-col items-center w-full lg:flex-row">
                <div className="flex items-center justify-center w-6 h-6 mb-1 rounded-full lg:mr-2 lg:mb-0">
                    <FontAwesomeIcon
                        style={{ color: iconColors[card.iconColor] }}
                        icon={card.icon}
                    />
                </div>
                <div className="text-blueGray-800 whitespace-nowrap text-overline xs:text-p3 md:text-p1">
                    {t(card.label)} <span className="lowercase">({t('Today')})</span>
                </div>
            </div>
            <div className="font-medium text-blueGray-800 text-sub md:text-h2 lg:w-full lg:mt-2 lg:text-promo2 lg:leading-tight">
                {card.value}
            </div>
        </div>
    );
};

export default Card;
